"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Filter = /*#__PURE__*/function () {
  function Filter() {
    (0, _classCallCheck2["default"])(this, Filter);
  }

  (0, _createClass2["default"])(Filter, [{
    key: "request",
    value: function request(config) {
      return Promise.resolve(config);
    }
  }, {
    key: "response",
    value: function response(_response) {
      return Promise.resolve(_response);
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (this.instance instanceof this === false) {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        this.instance = (0, _construct2["default"])(this, args);
      }

      return this.instance;
    }
  }, {
    key: "filterIterator",
    value: function filterIterator(filter, callback, isReverse) {
      var promise = Promise.resolve();
      var list = [];

      if (filter) {
        if (filter.prototype instanceof Filter) {
          list.push(filter);
        } else if (Array.isArray(filter)) {
          filter.forEach(function (item) {
            if (item.prototype instanceof Filter) {
              list.push(item);
            }
          });
        }

        if (isReverse) {
          list = list.reverse();
        }

        list.forEach(function (item) {
          promise = promise.then(function () {
            return callback(item.getInstance());
          });
        });
      }

      return promise;
    }
  }]);
  return Filter;
}();

exports["default"] = Filter;